/**
 * Classes which implements this interface can be rendered by an {@link IRenderer} instance.
 */
import {IRenderable} from './IRenderable';

export interface IStackeable extends IRenderable {

}
